<template lang="pug">
  div.wrapper(v-if="role")
    sidebar
    main.content
      .container
        router-view
        inform(v-if="modal_inform")
        footer
          .s-footer
            .container
              .s-footer__items.row
                .col.col-md-3
                  .s-footer__item
                    .s-footer__item-title Address
                    .s-footer__item-content 5312 Virginia Beach blvd
                      br
                      | Ste G
                    .s-footer__item-content Virginia Beach
                    .s-footer__item-content Virginia (VA)
                    .s-footer__item-content 23462
                .col.col-md-3
                  .s-footer__item-title Telephone
                  .s-footer__item-content 757-387-9797
</template>

<script>
import sStorageComponent from '@/views/s-storage/s-storage.vue';

export default {
  computed: {
    token() {
      return this.$store.getters.TOKEN;
    },
    role() {
      return this.$store.state.users.role;
    },
    modal_inform() {
      return this.$store.state.users.modal_inform;
    },
  },
  components: {
    s_storage_component: sStorageComponent,
  },
  created() {
    this.$store.dispatch('get_user_me');
  },
};
</script>
